export const Props = () => ({
  //Объект изображения
  image: {
    type: Object,
  },
});